/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IAccountingBankAccount } from 'app/shared/model/accounting-bank-account.model';

export interface IAccountingCurrency {
  id?: string;
  codeString?: string | null;
  name?: string | null;
  code?: string | null;
  precision?: number | null;
  subUnit?: number | null;
  symbol?: string | null;
  symbolFirst?: boolean | null;
  decimalMark?: string | null;
  thousandsSeparator?: string | null;
  country?: string | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  accounts?: IAccountingBankAccount[] | null;
}

export const defaultValue: Readonly<IAccountingCurrency> = {
  symbolFirst: false,
  active: false,
};
